import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import ErrorImg from 'src/assets/images/backgrounds/errorimg.svg';

const Error = ({ height = '100vh' }) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      height={height}
      textAlign="center"
      justifyContent="center">
      <Container maxWidth="md">
        <img src={ErrorImg} alt="404" />
        <Typography align="center" variant="h1" mb={4}>
          {t('Opps!!!')}
        </Typography>
        <Typography align="center" variant="h4" mb={4}>
          {t('This page you are looking for could not be found.')}
        </Typography>
        <Button
          color="primary"
          variant="contained"
          component={Link}
          to="/dashboard"
          disableElevation>
          {t('Go Back to Home')}
        </Button>
      </Container>
    </Box>
  );
};

export default Error;
